import React, { useEffect, useState } from 'react';
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import ActionProvider from "../components/ActionProvider";
import MessageParser from "../components/MessageParser";
import config from "../components/Config";
import downArrow from "../assets/down-arrow.svg"
import { Modal, Switch } from 'antd';
function Chat() {
  const validateInput = (input) => {
    return input.length > 0 && input.trim().length !== 0;
  };
  // get userId and company name from the URL
  const urlParams = new URLSearchParams(window.location.search);
  // console.log("urlParams", urlParams);
  const userId = urlParams.get('user_id');
  const company = urlParams.get('company_name');
  const [autoScrolling, setAutoScrolling] = useState(true);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [showArrow, setShowArrow] = useState(false);
  const [thinking, setThinking] = useState(false);
  const [atLastPointer, setAtLsstPointer] = useState(true);
  const [pii, setPii] = useState(false);
  if (userId) {
    localStorage.setItem("user_id", userId);
  }
  if (company) {
    localStorage.setItem("company_name", company);
  }
  useEffect(()=>{localStorage.setItem('pii', 'no_pii');},[]);
  useEffect(() => {
    if (thinking) {
      setTimeout(() => {
        setThinking(false);
      }, 700)
    }
  }, [thinking])

  useEffect(() => {
    const parent = document.getElementsByClassName('react-chatbot-kit-chat-message-container');
    if (parent) {
      const div = parent[0];

      const handleScroll = () => {
        const chatBotMsg = document.getElementsByClassName("react-chatbot-kit-chat-bot-message-container");
        if ([...chatBotMsg].find((msg) => msg.innerText === 'Thinking ...')) {
          setThinking(true)
        }

        const scrollTop = div.scrollTop;
        if (scrollTop < lastScrollTop && !thinking) {
          setAutoScrolling(false);
          if (!atLastPointer) {
            setShowArrow(true);
          }
        } else if (scrollTop > lastScrollTop && atLastPointer) {
          setShowArrow(false);
          setAutoScrolling(true);
        }
        setLastScrollTop(scrollTop);
      };

      if (div) {
        div.addEventListener('scroll', handleScroll);
      }

      return () => {
        if (div) {
          div.removeEventListener('scroll', handleScroll);
        }
      };
    }
  }, [lastScrollTop]);

  useEffect(() => {
    const container = document.querySelector('.react-chatbot-kit-chat-message-container');
    if (!container || !container.lastElementChild) return;

    const target = container.lastElementChild;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (localStorage.getItem('chatbot_typing') !== 'Typing') {
            setAtLsstPointer(true);
          }
          // container.lastElementChild.style="margin-bottom:30px;height:20px;background:blue;"
          // console.log('Last child is in of the viewport.');
        } else {
          setAtLsstPointer(false);
          // container.lastElementChild.style="margin-bottom:30px;height:20px;background:black;"
          // console.log('Last child is out of the viewport.');
        }
      });
    }, {
      threshold: 0.1,
    });

    observer.observe(target);

    return () => {
      observer.unobserve(target);
    };
  }, [])
  return (
    <div className="App flex justify-center items-center h-screen relative">
      <header className="App-header w-[100%]">
        <Chatbot
          config={config}
          actionProvider={ActionProvider}
          messageParser={MessageParser}
          headerText={`${process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"}`}
          placeholderText="Ask questions on your data.."
          pretext={localStorage.getItem('imt__pretexts')}
          // validator={validateInput}
          disableScrollToBottom={!autoScrolling}
        />
        {showArrow && (
          <div
            className='w-7 h-7 flex justify-center items-center absolute bottom-[15%] cursor-pointer bg-white'
            style={{ border: '1px solid #c5c6c7', borderRadius: '50%' }}
            onClick={() => {
              setAutoScrolling(true)
              setTimeout(() => {
                setShowArrow(false);
                setAutoScrolling(true);
              })
            }}
          >
            <img alt="" src={downArrow} className='h-3' />
          </div>
        )}
        <span className='absolute text-slate-700 text-base font-bold bottom-[6.7%] left-[10%]'>
          PII MODE
          <Switch
            value={pii}
            className='bg-slate-300 inline-block ml-2'
            onChange={(e) => {
              if (e) {
                Modal.confirm({
                  title: (
                    <strong>Are you sure that you want to send PII data outside ?</strong>
                  ),
                  okType: 'danger',
                  onOk() {
                    setPii(true);
                    localStorage.setItem('pii', 'pii');
                  },
                  onCancel() {
                    setPii(false);
                    localStorage.setItem('pii', 'no_pii');
                  }
                })
              } else {
                localStorage.setItem('pii', 'no_pii');
                setPii(false);
              }
            }}
          />
        </span>
        <div className="react-chatbot-kit-chat-disclaimer">
          AI is prone to making mistakes, so user discretion is necessary.
        </div>
      </header>
    </div>
  );
}

export default Chat;